import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type SkinnyLocationsService from 'garaje/services/skinny-locations';
import moment from 'moment-timezone';

const DEFAULT_PAGE_SIZE = 30;
const DEFAULT_DATE_RANGE = 'Today';

export default class LocationOverviewVisitorLogController extends Controller {
  @service declare skinnyLocations: SkinnyLocationsService;

  queryParams = [
    'endDate',
    'locationIds',
    'pageNumber',
    'pageSize',
    'query',
    'signedOut',
    'sortBy',
    'sortDirection',
    'startDate',
    'selectedDateRange',
  ];

  pageSize = DEFAULT_PAGE_SIZE;

  @tracked locationIds = '';
  @tracked pageNumber = 1;
  @tracked query = '';
  @tracked signedOut?: string;

  @tracked selectedDateRange = DEFAULT_DATE_RANGE;
  @tracked loadingData = true;
  @tracked startDate = moment().startOf('day').format();
  @tracked endDate = moment().endOf('day').format();

  @action
  setDateRange(option: string, start: string, end: string): void {
    this.startDate = start;
    this.endDate = end;
    this.selectedDateRange = option;
    this.pageNumber = 1;
  }

  @action
  setLocationIds(locationIds: string): void {
    this.locationIds = locationIds;
    this.pageNumber = 1;
  }

  @action
  setSignedOut(signedOut: string): void {
    this.signedOut = signedOut;
    this.pageNumber = 1;
  }

  @action
  setQuery(query: string): void {
    this.query = query;
    this.pageNumber = 1;
  }
}
